<div class="log-cinematic-section-summary">
    <!-- L7 log -->
    <ng-container *ngIf="(vsAppProfileType$ | async) === VsAppProfileType.L7">
        <!-- Client -->
        <div logCinematicSectionColumn>
            <h5 class="log-cinematic-section__column-title">
                {{ globalL10nKeys.clientLabel | vtranslate }}
            </h5>
            <ng-container *ngrxLet="(applicationLog$ | async | l7ClientInfo) as clientInfo">
                <!-- User ID -->
                <div logFieldTitle>{{ l10nKeys.userIdLabel | vtranslate }}</div>
                <div
                    *ngIf="clientInfo.user_id as userId; else na"
                    logFilter
                    property="user_id"
                    [value]="userId"
                    (onFilterAdd)="logCinematicStore.closeCinematic()"
                >
                    {{ userId }}
                </div>

                <!-- Location -->
                <span logFieldTitle>{{ l10nKeys.locationLabel | vtranslate }}</span>
                <div
                    logNationalFlag
                    [countryCode]="clientInfo.client_location"
                ></div>
                <span
                    *ngIf="clientInfo.client_location as location; else na"
                    logFilter
                    property="client_location"
                    [value]="location"
                    (onFilterAdd)="logCinematicStore.closeCinematic()"
                >
                    {{ location | countryCodeToName }}
                </span>

                <!-- OS -->
                <span logFieldTitle>{{ l10nKeys.operatingSystemLabel | vtranslate }}</span>
                <i
                    *ngIf="(clientInfo.client_os | logClientEnvToIconClass:'os') !== 'unknown'; else clrUnknownIcon"
                    class="icon-{{ clientInfo.client_os | logClientEnvToIconClass:'os' }}"
                ></i>
                <span
                    *ngIf="clientInfo.client_os as os; else na"
                    logFilter
                    property="client_os"
                    [value]="os"
                    (onFilterAdd)="logCinematicStore.closeCinematic()"
                >
                    {{ os }}
                </span>

                <!-- Device -->
                <span logFieldTitle>{{ l10nKeys.deviceLabel | vtranslate }}</span>
                <cds-icon
                    *ngIf="(clientInfo.client_device | logClientEnvToIconClass:'device') === 'desktop'"
                    class="log-cinematic-section-summary__clr-icon-with-margin-right"
                    shape="display"
                ></cds-icon>
                <cds-icon
                    *ngIf="(clientInfo.client_device | logClientEnvToIconClass:'device') === 'tablet'"
                    class="log-cinematic-section-summary__clr-icon-with-margin-right"
                    shape="tablet"
                    size="14"
                ></cds-icon>
                <span
                    *ngIf="clientInfo.client_device as device; else na"
                    logFilter
                    property="client_device"
                    [value]="device"
                    (onFilterAdd)="logCinematicStore.closeCinematic()"
                >
                    {{ device }}
                </span>

                <!-- Perfect Forward Secrecy -->
                <span logFieldTitle>{{ l10nKeys.perfectForwardSecrecyLabel | vtranslate }}</span>
                <span
                    *ngIf="clientInfo.pfs as pfs; else na"
                    logFilter
                    property="ssl_cipher"
                    [operator]="FilterOperatorType.CONTAINS"
                    [value]="pfs"
                    (onFilterAdd)="logCinematicStore.closeCinematic()"
                >
                    {{ pfs }}
                </span>

                <!-- Browser -->
                <span logFieldTitle>{{ l10nKeys.browserLabel | vtranslate }}</span>
                <i
                    *ngIf="(clientInfo.client_browser | logClientEnvToIconClass:'device') !== 'globe'; else clrWorldIcon"
                    class="icon-{{ clientInfo.client_browser | logClientEnvToIconClass:'browser' }}"
                ></i>
                <span
                    *ngIf="clientInfo.client_browser as browser; else na"
                    logFilter
                    property="client_browser"
                    [value]="browser"
                    (onFilterAdd)="logCinematicStore.closeCinematic()"
                >
                    {{ browser }}
                </span>

                <!-- Start Time -->
                <span logFieldTitle>{{ l10nKeys.startTimeLabel | vtranslate }}</span>
                <span *ngIf="clientInfo.startTime; else na">{{ clientInfo.startTime | aviDate:timeFormat }}</span>

                <!-- End Time -->
                <span logFieldTitle>{{ l10nKeys.endTimeLabel | vtranslate }}</span>
                <span *ngIf="clientInfo.endTime; else na">{{ clientInfo.endTime | aviDate:timeFormat }}</span>
            </ng-container>
        </div>

        <!-- Avi + Rules and Policies -->
        <div logCinematicSectionColumn>
            <h5 class="log-cinematic-section__column-title">
                {{ l10nKeys.vmwareAlbLabel | vtranslate }}
            </h5>

            <ng-container *ngrxLet="(applicationLog$ | async | nsxAlbInfo) as nsxAlbInfo">
                <span logFieldTitle>{{ l10nKeys.requestIdLabel | vtranslate }}</span>
                <span
                    *ngIf="nsxAlbInfo.request_id; else na"
                    logFilter
                    property="request_id"
                    [value]="nsxAlbInfo.request_id"
                    (onFilterAdd)="logCinematicStore.closeCinematic()"
                >
                    {{ nsxAlbInfo.request_id }}
                </span>

                <span logFieldTitle>{{ l10nKeys.redirectUriLabel | vtranslate }}</span>
                <span
                    *ngIf="nsxAlbInfo.redirected_uri as redirectedUri; else na"
                    logFilter
                    property="redirected_uri"
                    [value]="redirectedUri"
                    (onFilterAdd)="logCinematicStore.closeCinematic()"
                >
                    {{ redirectedUri }}
                </span>

                <span logFieldTitle>{{ globalL10nKeys.responseLengthLabel | vtranslate }}</span>
                <span
                    *ngIf="nsxAlbInfo.response_length !== undefined; else na"
                    logFilterList
                    property="server_response_length"
                    [value]="nsxAlbInfo.response_length"
                    (onFilterAdd)="logCinematicStore.closeCinematic()"
                >
                    {{ nsxAlbInfo.response_length }} {{ globalL10nKeys.shortBytesLabel | vtranslate }}
                </span>
            </ng-container>

            <h5 class="log-cinematic-section__column-title">
                {{ l10nKeys.rulesAndPoliciesLabel | vtranslate }}
            </h5>
            <ng-container *ngrxLet="(applicationLog$ | async | policyRules) as policyRules">
                <span logFieldTitle>{{ l10nKeys.persistenceIdLabel | vtranslate }}</span>
                <span
                    *ngIf="policyRules.persistent_session_id !== undefined; else na"
                    logFilter
                    property="persistent_session_id"
                    [value]="policyRules.persistent_session_id"
                    (onFilterAdd)="logCinematicStore.closeCinematic()"
                >
                    {{ policyRules.persistent_session_id }}
                </span>

                <span logFieldTitle>{{ l10nKeys.virtualHostRuleNameLabel | vtranslate }}</span>
                <span
                    *ngIf="policyRules.vh_match_rule as rule; else na"
                    logPartialSelectionFilter
                    property="vh_match_rule"
                    [value]="rule"
                    position="right"
                    (onFilterAdd)="logCinematicStore.closeCinematic()"
                ></span>

                <span logFieldTitle>{{ l10nKeys.networkSecurityPolicyRuleLabel | vtranslate }}</span>
                <span
                    *ngIf="policyRules.networkSecurityPolicyRule as rule; else na"
                    logPartialSelectionFilter
                    property="network_security_policy_rule_name"
                    [value]="rule"
                    position="right"
                    (onFilterAdd)="logCinematicStore.closeCinematic()"
                ></span>

                <span logFieldTitle>{{ l10nKeys.httpSecurityPolicyRuleLabel | vtranslate }}</span>
                <span
                    *ngIf="policyRules.httpSecurityPolicyRule as rule; else na"
                    logPartialSelectionFilter
                    property="http_security_policy_rule_name"
                    [value]="rule"
                    position="right"
                    (onFilterAdd)="logCinematicStore.closeCinematic()"
                ></span>

                <span logFieldTitle>{{ l10nKeys.httpRequestPolicyRuleLabel | vtranslate }}</span>
                <span
                    *ngIf="policyRules.httpRequestPolicyRule as rule; else na"
                    logPartialSelectionFilter
                    property="http_request_policy_rule_name"
                    [value]="rule"
                    position="right"
                    (onFilterAdd)="logCinematicStore.closeCinematic()"
                ></span>

                <span logFieldTitle>{{ l10nKeys.httpResponsePolicyRuleLabel | vtranslate }}</span>
                <ng-container >
                    <span
                        *ngIf="policyRules.httpResponsePolicyRule as rule; else na"
                        logPartialSelectionFilter
                        property="http_response_policy_rule_name"
                        [value]="rule"
                        position="right"
                        (onFilterAdd)="logCinematicStore.closeCinematic()"
                    ></span>
                </ng-container>
            </ng-container>
            <log-policy-grid
                [ssl]="ssl$ | async"
                [hasAuthenticationLogs]="hasAuthenticationLogs$ | async"
                [icapLog]="icapLog$ | async"
                [wafLog]="wafLog$ | async"
                [botManagementLog]="botManagementLog$ | async"
                [datascriptInfo]="datascriptInfo$ | async"
            ></log-policy-grid>
        </div>

        <!-- Client Request Info & Server Response Infomation -->
        <div logCinematicSectionColumn>
            <!-- Client Request Infomation -->
            <h5 class="log-cinematic-section__column-title">
                {{ l10nKeys.clientRequestInfoLabel | vtranslate }}
            </h5>
            <ng-container *ngrxLet="(applicationLog$ | async | requestInfo) as requestInfo">
                <span logFieldTitle>{{ globalL10nKeys.hostLabel | vtranslate }}</span>
                <span
                    *ngIf="requestInfo.host; else na"
                    logPartialSelectionFilter
                    property="host"
                    [value]="requestInfo.host"
                    position="right"
                    (onFilterAdd)="logCinematicStore.closeCinematic()"
                ></span>

                <span logFieldTitle>{{ globalL10nKeys.requestLabel | vtranslate }}</span>
                <ng-container *ngIf="(applicationLog$ | async | requestDetails) as requestDetails; else na">
                    <span
                        *ngIf="requestDetails.method as method"
                        logFilter
                        property="method"
                        [value]="method"
                        (onFilterAdd)="logCinematicStore.closeCinematic()"
                    >
                        {{ method }}
                    </span>

                    <span
                        *ngIf="requestDetails.http_version as httpVersion"
                        logFilter
                        property="http_version"
                        [value]="httpVersion"
                        (onFilterAdd)="logCinematicStore.closeCinematic()"
                    >
                        {{ httpVersion | logHttpVersion }}
                    </span>

                    <ng-container *ngIf="requestDetails.request_length !== undefined">
                        (<span
                            logFilterList
                            property="request_length"
                            [value]="requestDetails.request_length"
                            (onFilterAdd)="logCinematicStore.closeCinematic()"
                        >
                            {{ requestDetails.request_length }} {{ globalL10nKeys.shortBytesLabel | vtranslate }}
                        </span>)
                    </ng-container>

                    <span
                        *ngIf="requestDetails.request_content_type as contentType"
                        logPartialSelectionFilter
                        property="request_content_type"
                        [value]="contentType"
                        (onFilterAdd)="logCinematicStore.closeCinematic()"
                    ></span>
                </ng-container>

                <span logFieldTitle>{{ l10nKeys.unparsedUriLabel | vtranslate }}</span>
                <span
                    *ngIf="requestInfo.orig_uri as uri; else na"
                    logPartialSelectionFilter
                    property="orig_uri"
                    [value]="uri"
                    position="right"
                    (onFilterAdd)="logCinematicStore.closeCinematic()"
                ></span>

                <span logFieldTitle>{{ l10nKeys.rewrittenUriPathLabel | vtranslate }}</span>
                <span
                    *ngIf="requestInfo.rewritten_uri_path as uri; else na"
                    logPartialSelectionFilter
                    property="rewritten_uri_path"
                    [value]="uri"
                    position="right"
                    (onFilterAdd)="logCinematicStore.closeCinematic()"
                ></span>

                <span logFieldTitle>{{ l10nKeys.uriLabel | vtranslate }}</span>
                <span
                    *ngIf="requestInfo.uri as uri; else na"
                    logPartialSelectionFilter
                    property="uri_path"
                    [value]="uri"
                    [noSearchIcon]="!!requestInfo.uriQuery"
                    position="right"
                    (onFilterAdd)="logCinematicStore.closeCinematic()"
                ></span>
                <ng-container *ngIf="requestInfo.uriQuery as uriQuery">
                    <span class="log-cinematic-section-summary__uri-query-question-mark">
                        &nbsp;?&nbsp;
                    </span>
                    <span
                        logPartialSelectionFilter
                        property="uri_query"
                        [value]="uriQuery"
                        position="right"
                    ></span>
                </ng-container>

                <span logFieldTitle>{{ l10nKeys.userAgentLabel | vtranslate }}</span>
                <span
                    *ngIf="requestInfo.userAgent; else na"
                    logPartialSelectionFilter
                    property="user_agent"
                    [value]="requestInfo.userAgent"
                    position="right"
                    (onFilterAdd)="logCinematicStore.closeCinematic()"
                ></span>
            </ng-container>

            <!-- Server Response Information -->
            <h5 class="log-cinematic-section__column-title">
                {{ l10nKeys.serverResponseInfoLabel | vtranslate }}
            </h5>
            <ng-container *ngrxLet="(applicationLog$ | async | responseInfo) as responseInfo">
                <span logFieldTitle>{{ l10nKeys.contentTypeLabel | vtranslate }}</span>
                <span
                    *ngIf="responseInfo.response_content_type as contentType; else na"
                    logPartialSelectionFilter
                    property="response_content_type"
                    [value]="contentType"
                    position="right"
                    (onFilterAdd)="logCinematicStore.closeCinematic()"
                ></span>

                <span logFieldTitle>{{ l10nKeys.serverRedirectUriLabel | vtranslate }}</span>
                <span
                    *ngIf="responseInfo.server_side_redirect_uri as redirectedUri; else na"
                    logFilter
                    property="server_side_redirect_uri"
                    [value]="redirectedUri"
                    (onFilterAdd)="logCinematicStore.closeCinematic()"
                >
                    {{ redirectedUri }}
                </span>

                <span logFieldTitle>{{ l10nKeys.serverResponseLengthLabel | vtranslate }}</span>
                <span
                    *ngIf="responseInfo.serverResponseLength !== undefined; else na"
                    logFilter
                    property="server_response_length"
                    [value]="responseInfo.serverResponseLength"
                    (onFilterAdd)="logCinematicStore.closeCinematic()"
                >
                    {{ responseInfo.serverResponseLength }} {{ globalL10nKeys.shortBytesLabel | vtranslate }}
                </span>

                <span logFieldTitle>{{ l10nKeys.grpcStatusLabel | vtranslate }}</span>
                <ng-container *ngIf="responseInfo.grpcStatus !== undefined; else na">
                    <span
                        logFilter
                        property="grpc_status"
                        [value]="responseInfo.grpcStatus"
                        (onFilterAdd)="logCinematicStore.closeCinematic()"
                    >
                        {{ responseInfo.grpcStatus }}
                    </span>
                </ng-container>
            </ng-container>
        </div>
    </ng-container>

    <!-- L4 log -->
    <ng-container *ngIf="(vsAppProfileType$ | async) === VsAppProfileType.L4">
        <!-- Location -->
        <div logCinematicSectionColumn>
            <ng-container *ngrxLet="(connectionLog$ | async | l4ClientInfo) as clientInfo">
                <span
                    logFieldTitle
                    [withMarginTop]="false"
                >
                    {{ l10nKeys.locationLabel | vtranslate }}
                </span>
                <div
                    logNationalFlag
                    [countryCode]="clientInfo.client_location"
                ></div>
                <span
                    *ngIf="clientInfo.client_location as location; else na"
                    logFilter
                    property="client_location"
                    [value]="location"
                    (onFilterAdd)="logCinematicStore.closeCinematic()"
                >
                    {{ location | countryCodeToName }}
                </span>
                <!-- Start Time -->
                <span logFieldTitle>{{ l10nKeys.startTimeLabel | vtranslate }}</span>
                <span *ngIf="clientInfo.startTime; else na">{{ clientInfo.startTime | aviDate:timeFormat }}</span>

                <!-- End Time -->
                <span logFieldTitle>{{ l10nKeys.endTimeLabel | vtranslate }}</span>
                <span *ngIf="clientInfo.endTime; else na">{{ clientInfo.endTime | aviDate:timeFormat }}</span>
            </ng-container>
        </div>
    </ng-container>

    <!-- DNS log -->
    <ng-container *ngIf="(vsAppProfileType$ | async) === VsAppProfileType.DNS">
        <!-- Two Client columns -->
        <ng-container *ngrxLet="(connectionLog$ | async | dnsClientInfo) as clientInfo">
            <div logCinematicSectionColumn>
                <h5 class="log-cinematic-section__column-title">
                    {{ globalL10nKeys.clientLabel | vtranslate }}
                </h5>

                <!-- Location -->
                <span logFieldTitle>{{ l10nKeys.locationLabel | vtranslate }}</span>
                <div
                    logNationalFlag
                    [countryCode]="clientInfo.client_location"
                ></div>
                <span
                    *ngIf="clientInfo.client_location as location; else na"
                    logFilter
                    property="client_location"
                    [value]="location"
                    (onFilterAdd)="logCinematicStore.closeCinematic()"
                >
                    {{ location | countryCodeToName }}
                </span>

                <!-- Start Time -->
                <span logFieldTitle>{{ l10nKeys.startTimeLabel | vtranslate }}</span>
                <span *ngIf="clientInfo.startTime; else na">{{ clientInfo.startTime | aviDate:timeFormat }}</span>

                <!-- End Time -->
                <span logFieldTitle>{{ l10nKeys.endTimeLabel | vtranslate }}</span>
                <span *ngIf="clientInfo.endTime; else na">{{ clientInfo.endTime | aviDate:timeFormat }}</span>
            </div>

            <!-- DNS Query Type -->
            <div
                logCinematicSectionColumn
                [withDivider]="false"
                [withContentTopPadding]="true"
            >
                <div logFieldTitle>{{ l10nKeys.dnsQueryTypeLabel | vtranslate }}</div>
                <span
                    *ngIf="clientInfo.dns_qtype as queryType; else na"
                    logFilter
                    property="dns_qtype"
                    [value]="queryType"
                    (onFilterAdd)="logCinematicStore.closeCinematic()"
                >
                    {{ enumLabelHash[queryType] }}
                </span>

                <div logFieldTitle>{{ globalL10nKeys.protocolLabel | vtranslate }}</div>
                <span
                    *ngIf="clientInfo.protocol as protocol; else na"
                    logFilter
                    property="protocol"
                    [value]="protocol"
                    (onFilterAdd)="logCinematicStore.closeCinematic()"
                >
                    {{ enumLabelHash[protocol] }}
                </span>

                <div logFieldTitle>{{ l10nKeys.seClosedTcpConnectionLabel | vtranslate }}</div>
                <span
                    *ngIf="clientInfo.dns_tcp_conn_close_from_se as se_closed_tcp_connection; else na"
                    logFilter
                    property="dns_tcp_conn_close_from_se"
                    [value]="se_closed_tcp_connection"
                    (onFilterAdd)="logCinematicStore.closeCinematic()"
                >
                    {{ se_closed_tcp_connection }}
                </span>
            </div>
        </ng-container>

        <!-- Load Balancer column -->
        <div logCinematicSectionColumn>
            <h5 class="log-cinematic-section__column-title">
                {{ globalL10nKeys.loadBalancerLabel | vtranslate }}
            </h5>

            <ng-container *ngrxLet="(connectionLog$ | async | dnsLoadBalancerInfo) as dnsLoadBalancerInfo">
                <div logFieldTitle>{{ l10nKeys.gslbServiceLabel | vtranslate }}</div>
                <span
                    *ngIf="dnsLoadBalancerInfo.gslbservice as gslbservice; else na"
                    logFilter
                    property="gslbservice"
                    [value]="gslbservice"
                    (onFilterAdd)="logCinematicStore.closeCinematic()"
                >
                    {{ gslbservice }}
                </span>

                <div logFieldTitle>{{ l10nKeys.gslbPoolLabel | vtranslate }}</div>
                <div
                    *ngIf="dnsLoadBalancerInfo.gslbpool_name as gslbPoolName; else na"
                    logFilter
                    property="gslbpool_name"
                    [value]="gslbPoolName"
                    (onFilterAdd)="logCinematicStore.closeCinematic()"
                >
                    {{ gslbPoolName }}
                </div>

                <div logFieldTitle>{{ globalL10nKeys.queryLabel | vtranslate }}</div>
                <div
                    *ngIf="dnsLoadBalancerInfo.query_or_response !== undefined; else na"
                    logFilter
                    property="query_or_response"
                    [value]="dnsLoadBalancerInfo.query_or_response"
                    (onFilterAdd)="logCinematicStore.closeCinematic()"
                >
                    {{ dnsLoadBalancerInfo.query_or_response }}
                </div>

                <div logFieldTitle>{{ l10nKeys.recursionAvailableLabel | vtranslate }}</div>
                <span
                    *ngIf="dnsLoadBalancerInfo.recursion_available !== undefined; else na"
                    logFilter
                    property="dns_response.recursion_available"
                    [value]="dnsLoadBalancerInfo.recursion_available"
                    (onFilterAdd)="logCinematicStore.closeCinematic()"
                >
                    {{ dnsLoadBalancerInfo.recursion_available }}
                </span>
            </ng-container>
        </div>
    </ng-container>
</div>

<ng-template #na>
    <span logEmptyField></span>
</ng-template>

<ng-template #clrUnknownIcon>
    <cds-icon shape="unknown-status"></cds-icon>
</ng-template>

<ng-template #clrWorldIcon>
    <cds-icon
        class="log-cinematic-section-summary__clr-icon-with-margin-right"
        shape="world"
    ></cds-icon>
</ng-template>
